import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { StringsService } from '../../services/strings/strings.service';
import { CancellationPage } from '../../types/strings.type';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { ReservationService } from '../../services/reservation/reservation.service';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Reservation } from '../../types/booking.type';
import { ProductService } from '../../services/product/product.service';
import { ProductListing } from '../../types/product.type';

@Component({
    selector: 'rttd-booking-cancellation',
    templateUrl: './booking-cancellation.component.html',
    styleUrls: ['./booking-cancellation.component.scss']
})
export class BookingCancellationComponent implements OnInit {
    content: CancellationPage;

    showBack = false;

    constructor(
        private stringsService: StringsService,
        public activatedRoute: ActivatedRoute,
        public appSettings: AppSettings,
        private reservationService: ReservationService,
        private userSelectionService: UserSelectionsService,
        private productService: ProductService,
        private router: Router,
        private location: Location
    ) {}

    ngOnInit() {
        this.stringsService.get().subscribe((content: CancellationPage) => this.content = content['CancellationPage']);
        this.getCancellationId();
        this.backStatus();
    }

    /**
     * @description Cancel the reservation.
     *
     * Calls reservationService.cancelReservation() to cancel the currently stored
     * reservation.
     */
    cancelBooking() {
        this.reservationService.cancelReservation().subscribe(res => {
            this.navigateToConfirmation();
        });
    }

    /**
     * @description Go back to the confirmation page.
     *
     * @note This method is called by the back button which is only present if
     * we have location history.
     */
    goBack() {
        this.router.navigate(['/booking-confirmation'], {
            skipLocationChange: true
        });
    }

    /**
     * @description Check location history to determine if the back
     * button should be displayed.
     */
    private backStatus() {
        const state: any = this.location.getState();
        if (state && state.navigationId > -1 && !this.appSettings.eventJourney) {
            this.showBack = true;
        }
    }

    /**
     * @description Get the reservation ID from the route params.
     */
    private getCancellationId() {
        const reservationId = this.activatedRoute.snapshot.params.id;
        if (reservationId) {
            this.setUserSelectionsFromId(reservationId);
        }
    }

    /**
     * @description Given a reservation ID, get the reservation and set the user selection
     * information to that of the reservation.
     */
    private setUserSelectionsFromId(id: string) {
        this.reservationService.getReservation(id).subscribe(
            (reservation: Reservation) => {
                // If the status is 'cancelled', then we take the user straight to
                // the cancelled-confirmation route.
                if (reservation.status === 'cancelled') {
                    this.navigateToConfirmation();
                    return;
                }
                this.userSelectionService.set('startTime', reservation.start);
                this.userSelectionService.set('endTime', reservation.end);

                this.productService.getListings().subscribe((data: ProductListing[]) => {
                    data.forEach(p => {
                        const item = p.items.find(subProduct => subProduct.modelTreeRef === reservation.modelTreeRef);
                        if (item) {
                            setTimeout(() => {
                                this.userSelectionService.set('product', item);
                            }, 1);
                        }
                    });
                });
            }
        );
    }

    /**
     * @description Navigates to the booking cancelled confirmation page.
     */
    private navigateToConfirmation() {
        this.router.navigate(['/booking-cancelled'], {
            skipLocationChange: true
        });
    }

}
